import clsx from "clsx";
import zebraShape01 from "../../assets/img/shapes/zebra-shape-01.webp";


const ZebraShape02 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-zebra-shape-02", props.className)}>
            <img src={zebraShape01} alt="rmdr-zebra-shape-02" loading="lazy" width={236} height={376} />
        </div>
    )

}

export default ZebraShape02;
